import { useTransportQuery } from "@/transport"

export const HOME_ACTIVATION_STALE_TIME_MS = 1000 * 60 * 5

interface UseHomeActivationOptions {
  enabled?: boolean
}

export function useHomeActivation(options?: UseHomeActivationOptions) {
  return useTransportQuery({
    operation: "homeActivation",
    options: {
      enabled: options?.enabled ?? true,
      staleTime: HOME_ACTIVATION_STALE_TIME_MS,
    },
  })
}
